import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import {updateControl} from '../../actions/control'
import {showLiveViewModal} from '../../utils/liveView/showLiveViewModal'
import {resetControl} from '../../utils/liveView/resetControl'
import find from 'lodash/find'
import FloatingNPControl from '../../components/liveView/FloatingNPControl'

//This is the minimised live view


const isPageWithFloatingNPControl = (location) => { 
	if(
		!(location.pathname.indexOf('/liveview')>-1)  &&
		location.hash!=='#now-playing' &&
		!(location.pathname.indexOf('/classRoster')>-1) &&
		!(location.pathname.indexOf('/creatorslist')>-1) &&
		!(location.pathname.indexOf('/explorer')>-1) &&
		!(location.pathname.indexOf('/packreview')>-1) &&
		!(location.pathname.indexOf('/scan-helper')>-1) 
		
	)return true
	else return false
}



class FloatingNPControlContainer extends Component {


	constructor() {
		super()		
		this.stopLiveView=this.stopLiveView.bind(this)
	}

	stopLiveView(){
		this.props.resetControl()
	}

	render() {
		const {control,section}=this.props
		const hasItemInControl=(control && (control.setPoll || control.currentPoll))
		const {location}=this.props.history
	
		if( hasItemInControl && isPageWithFloatingNPControl(location) && !this.props.hasLiveViewNotification){		
			return( 
				<FloatingNPControl 
					section={section}
					showLiveViewModal={showLiveViewModal}
					stopLiveView={this.stopLiveView}
					control={control}
				/>
			)
			
			
		}else return null
	}
}


function mapStateToProps(state) {
	var control=state.control
	let section=null
	if(state.control){
		section=find(state.sections, {'id':state.control.section})
	}
	return {
		 control:control,
		 section:section,
		 hasLiveViewNotification:state.hasLiveViewNotification,
	}
}




export default withRouter(connect(
	 mapStateToProps,
	{ updateControl,resetControl}
)(FloatingNPControlContainer))



